<template>
  <!-- q+a messages window -->
  <div class="messages termina-reg">
    <div class="messages-full-chat pt-5" ref="conversationContainer">
      <div
        v-for="(message, index) in displayedMessages"
        :key="index"
        :class="[
          message.type === 'outgoing' ? 'outgoing-message' : 'incoming-message'
        ]"
      >
        <div v-if="message.type !== 'outgoing'" class="incoming-message-img">
          <img
            class="img-fluid rounded-circle"
            :src="message.icon"
            alt="avatar"
          />
        </div>

        <div v-if="message.type === 'incoming'" class="received-message">
          <div class="received-with-message">
            <vue-markdown class="received-with-message-text">
              {{ message.text }}
            </vue-markdown>
            <span class="time-date"></span>
          </div>
        </div>

        <div v-else-if="message.type === 'correct'" class="received-message">
          <div class="received-with-message-correct">
            <vue-markdown>
              {{ message.text }}
            </vue-markdown>
            <!-- <span class="time-date"> 11:01 AM | Today</span> -->
            <span class="time-date"></span>
          </div>
        </div>

        <div v-else-if="message.type === 'incorrect'" class="received-message">
          <div class="received-with-message-wrong">
            <vue-markdown>
              {{ message.text }}
            </vue-markdown>
            <!-- <span class="time-date"> 11:01 AM | Today</span> -->
            <span class="time-date"></span>
          </div>
        </div>

        <div v-else-if="message.type === 'hint'" class="received-message">
          <div class="received-with-message-hint">
            <vue-markdown>
              **Hint:**

              {{ message.text }}
            </vue-markdown>
          </div>
        </div>
        <div v-else class="sent-message">
          <p>
            {{ message.text }}
          </p>
          <!-- <span class="time-date"> 11:01 AM | June 9</span> -->
          <span class="time-date"></span>
        </div>
      </div>

      <div v-if="shouldShowTimer" class="incoming-message">
        <div class="incoming-message-img">
          <img
            class="img-fluid rounded-circle"
            src="../assets/images/timer-avatar.svg"
            alt="avatar"
          />
        </div>
        <div class="received-message">
          <div class="received-with-message">
            <p id="timer-wrapper">
              <strong class="text"> {{ timerText }}</strong>
              <br />
              <span class="points"
                ><h3
                  v-if="showPointsRemaining"
                  id="points-timer"
                  class="termina-bold"
                  :class="timerClass"
                >
                  {{ pointsRemaining }}
                </h3></span
              >
              <span id="timer"
                ><h2 v-if="timeRemaining > 0" id="time-centered">
                  {{ timeRemainingText }}
                </h2>
              </span>
            </p>
            <span class="time-date">Just Now</span>
          </div>
        </div>
      </div>

      <div v-if="messagePlaceholder" class="incoming-message">
        <div class="incoming-message-img">
          <img
            class="img-fluid rounded-circle"
            :src="messagePlaceholder.icon"
            alt="avatar"
          />
        </div>
        <div class="received-message">
          <div class="received-with-message">
            <p>
              <img
                src="../assets/images/chat-incoming.gif"
                alt="chat incoming"
                style="mix-blend-mode: multiply !important; height: 14px;"
              />
            </p>

            <span class="time-date">{{ messagePlaceholder.text }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import config from '../config'
import VueMarkdown from 'vue-markdown'

export default {
  components: {
    VueMarkdown
  },
  props: {
    messages: { type: Array, required: true },
    showPlaceholders: { type: Boolean, required: true },
    timeRemaining: { type: Number },
    maxTimeRemaining: { type: Number },
    pointsRemaining: { type: Number },
    timeReducesPoints: { type: Boolean }
  },
  data() {
    return {
      displayedMessages: [],
      messagePlaceholder: null,
      messageLoopTimeout: null
    }
  },
  mounted() {
    this.displayNewMessages()
  },
  watch: {
    messages: function() {
      if (this.messages.length === 0) {
        this.displayedMessages = []
      } else if (
        !this.showPlaceholders ||
        this.messages.length > this.displayedMessages.length + 2
      ) {
        this.displayedMessages = [...this.messages]
      } else if (!this.messageLoopTimeout) {
        this.displayNewMessages()
      }
    },
    displayedMessages: function() {
      this.$nextTick(function() {
        var container = this.$refs.conversationContainer
        container.scrollTop = container.scrollHeight
      })
    },
    messagePlaceholder: function() {
      this.$nextTick(function() {
        var container = this.$refs.conversationContainer
        container.scrollTop = container.scrollHeight
      })
    },
    timerText: function() {
      this.$nextTick(function() {
        var container = this.$refs.conversationContainer
        container.scrollTop = container.scrollHeight
      })
    },
    shouldShowTimer: function() {
      this.$nextTick(function() {
        var container = this.$refs.conversationContainer
        container.scrollTop = container.scrollHeight
      })
    }
  },
  computed: {
    shouldShowTimer() {
      return (
        this.timeRemaining != null &&
        this.timeRemaining < this.maxTimeRemaining + 2000
      )
    },
    showPointsRemaining() {
      return this.timeRemaining > 0 && this.pointsRemaining != null
    },
    timeRemainingText() {
      if (this.timeRemaining > this.maxTimeRemaining) {
        return this.formatTimeRemaining(this.maxTimeRemaining)
      }

      return this.formatTimeRemaining(this.timeRemaining)
    },
    timerText() {
      if (!this.timeRemaining) {
        return "Time's up!"
      }

      if (this.timeRemaining > this.maxTimeRemaining) {
        return 'Starting the timer...'
      }

      if (this.timeReducesPoints) {
        return 'Points are reducing'
      }

      if (this.timeRemaining <= 15000) {
        return 'Almost out of time!'
      } else if (this.timeRemaining <= 30000) {
        return 'Not long left now...'
      } else if (this.timeRemaining <= 45000) {
        return 'Still plenty of time... keep going'
      } else {
        return 'Ok, the timer is running! Good Luck!'
      }
    },
    timerClass() {
      if (!this.timeRemaining) {
        return 'BgFinished'
      } else if (this.timeRemaining <= 15000) {
        return 'fifteenBg'
      } else if (this.timeRemaining <= 30000) {
        return 'thirtyBg'
      } else if (this.timeRemaining <= 45000) {
        return 'fortyFiveBg'
      } else {
        return 'sixtyBg'
      }
    }
  },
  methods: {
    formatTimeRemaining(ms) {
      const SHOW_THOUSANTHS = false
      const SHOW_TENTHS = false

      function pad(pad, str) {
        return (pad + str).slice(-pad.length)
      }

      const seconds = Math.floor((ms / 1000) % 60)
      const minutes = Math.floor((ms / 1000 / 60) % 60)

      let output =
        pad('00', minutes.toString()) + ':' + pad('00', seconds.toString())

      if (SHOW_THOUSANTHS) {
        const remainingMilliseconds = ms - seconds * 1000 - minutes * 60 * 1000

        output = output + '.' + pad('000', remainingMilliseconds.toString())
      }

      if (SHOW_TENTHS) {
        const remainingHundreths = ms - seconds * 1000 * 100

        output = output + '.' + pad('0', remainingHundreths.toString())
      }

      return output
    },
    displayNewMessages() {
      this.messageLoopTimeout = null
      if (this.messages.length === this.displayedMessages.length) {
        // No new messages.
        return
      }

      if (this.messages.length === 0) {
        return
      }

      let delayBeforeRecursiveCall = config.messageLoopDelay
      const message = this.messages[this.displayedMessages.length]
      if (message.type === 'outgoing') {
        if (this.messagePlaceholder) {
          console.log(
            `👮‍♀️👮‍♀️👮‍♀️ Next messages is 'outgoing' type but placeholder is displayed 👮‍♀️👮‍♀️👮‍♀️`
          )
        }
        this.displayedMessages.push(message)
      } else if (this.messagePlaceholder) {
        if (this.messagePlaceholder.from !== message.from) {
          console.log(
            `👮‍♀️👮‍♀️👮‍♀️ Placeholder displayed but not for current message type! 👮‍♀️👮‍♀️👮‍♀️`
          )
        }
        this.messagePlaceholder = undefined
        this.displayedMessages.push(message)
      } else {
        this.messagePlaceholder = {
          from: message.from,
          text: `${message.from} is typing...`,
          icon: message.icon
        }
        delayBeforeRecursiveCall = config.messagePlaceholderDelay
      }
      this.messageLoopTimeout = setTimeout(() => {
        this.displayNewMessages()
      }, delayBeforeRecursiveCall)
    }
  }
}
</script>

<style scoped>
.points h3:after {
  content: 'points';
  font-size: 9px;
  position: relative;
  display: block;
  padding: 0 !important;
  margin: 0;
  line-height: 0 !important;
  text-align: center;
  /* margin: 0 auto; */
  margin-top: -16px;
  justify-content: center;
}

.messages-full-chat {
  scroll-behavior: smooth;
}
.received-message {
  animation: fadeIn ease 3s;
  -webkit-animation: fadeIn ease 3s;
  -moz-animation: fadeIn ease 3s;
  -o-animation: fadeIn ease 3s;
  -ms-animation: fadeIn ease 3s;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-moz-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-webkit-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-o-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@-ms-keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
